const projectsData = [
    {
      title: "PAYROLL SERVICES",
      image: "./ecommerce.svg",
      description:
        "Through our strong technology infrastructure, unrivalled statutory compliance team and proven payroll operational model, Novho ensures a 100% error free payroll services, which guarantees speed of service.",
      link: "/",
    },
    {
      title: "CUSTOM IT-DEVELOPMENT",
      image: "./pizzas.svg",
      description:
        "Outsourcing helps organizations fulfill their need for newer customized solutions.Our high quality talent, up to date technology & domain expertise along with mature offshore development methodology  has always resulted in ontime.",
      link: "/",
    },
    {
      title: "Permanent Recruitment",
      image: "./hotels.svg",
      description:
        "An exhaustive mapping process that identifies all the potential candidates in the sector, leaving no one off the table for job placement.A candidate who is compatible with the company’s culture and long term strategic direction are executed by a highly responsive team.",
      link: "/",
    },
    {
      title: "IT Manpower Recruitment Services",
      image: "./jobs.svg",
      description:
        "We cater to the manpower recruitment requirements of companies ranging from start-ups to large organisations and across all industry sectors like IT. we can provide you candidates from the same industry background or totally a different domain.",
      link: "/",
    },
    {
      title: "Manpower Recruitment",
      image: "./socialmedia.svg",
      description:
        "For the IT industry, we have a well-established testing process that includes tough online tests and filter the productive candidates and We have again built up a large database of potential candidates that we can bring on board for you quickly.",
      link: "/",
    },
    {
      title: "Payment Gateway/Cloud Services",
      image: "./cars.svg",
      description:
        "Authoritatively streamline your strategic markets without user-centric potentialities. Credibly integrate progressive technologies.We are up-to date with different third party libraries which can add fuel to your application.",
      link: "/",
    },
  ];
  
  export default projectsData;